import { apiClient } from "../lib/api";

// Management-facing interview scheduling engine endpoints (permission-gated).
export const interviewSchedulingApi = {
  getSettings: () => apiClient.get("/recruitment/interviews/settings"),
  updateSettings: (payload) => apiClient.patch("/recruitment/interviews/settings", payload),
  listBlackoutDates: () => apiClient.get("/recruitment/interviews/blackout-dates"),
  addBlackoutDate: (payload) => apiClient.post("/recruitment/interviews/blackout-dates", payload),
  removeBlackoutDate: (id) => apiClient.delete(`/recruitment/interviews/blackout-dates/${id}`),
  listBookings: (params) => apiClient.get("/recruitment/interviews/bookings", { params }),
  getBooking: (id) => apiClient.get(`/recruitment/interviews/bookings/${id}`),
  createManualBooking: (payload) => apiClient.post("/recruitment/interviews/bookings/manual", payload),
  confirmBooking: (id) => apiClient.post(`/recruitment/interviews/bookings/${id}/confirm`),
  proposeTime: (id, payload) => apiClient.post(`/recruitment/interviews/bookings/${id}/propose-time`, payload),
  rescheduleBooking: (id, payload) => apiClient.post(`/recruitment/interviews/bookings/${id}/reschedule`, payload),
  cancelBooking: (id, reason) => apiClient.post(`/recruitment/interviews/bookings/${id}/cancel`, { reason }),
  assignInterviewer: (id, interviewerName) => apiClient.post(`/recruitment/interviews/bookings/${id}/assign-interviewer`, { interviewer_name: interviewerName }),
  markCompleted: (id) => apiClient.post(`/recruitment/interviews/bookings/${id}/complete`),
  markNoShow: (id) => apiClient.post(`/recruitment/interviews/bookings/${id}/no-show`),
};
